import {XauditModel} from '../xaudit.model';
import {AppointmentDetailDataModel} from './appointment-detail-data.model';
import {PatientFlagDataModel} from '../patient/patient-flag-data.model';
import {AppointmentFlagDataModel} from './appointment-flag-data.model';
import {CaseProcedureConfigurationModel} from '../caseProcedures/case-procedure-configuration.model';
import {AppointmentOperatoryDataModel} from './appointment-operatory-data.model';

export class DataAppointmentModel extends XauditModel{
  AppointmentId: string;
  LOCID: number;
  enumApptTypeId: string;
  enumApptStatusId: string;
  PatientId: string;
  Resource_OperatoryId: string;
  Label_DoctorId: string;
  Subject: string;
  Description: string;
  StartDate: string;
  EndDate: string;
  Duration: number;
  isAllDay: boolean;
  isFirstVisit: boolean;
  CaseProcedureId: string;
  isExistingCase: boolean;
  PatientCaseId: string;
  CaseWorkItemId: string;
  NoteGroupId: string; // do not use
  ReminderInfo: string;
  RecurrenceInfo: string;
  isReservation: boolean;
  isPastedReschedule: boolean;

  dataAppoitmentDetails: AppointmentDetailDataModel[] = [];
  dataAppoitmentFlags: AppointmentFlagDataModel[] = [];
  dataAppoitmentOperatories: AppointmentOperatoryDataModel[] = [];

  // Front end only
  CaseWorkItemFormsId: string;
  dataPatientFlags: PatientFlagDataModel[] = [];
  Procedure: CaseProcedureConfigurationModel;
  PatientFullInfo: string;
  smsMessage: string = '';
  isDuplicateForSecondaryOps = false;
  parentAppointmentId: string;
  procedureDescription: string;
  locationDescription: string;
  reasonDescription: string;
}
